import React, { Component } from "react";
import { Row, Col } from "shards-react";
import { Button, FormGroup, FormControl } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import medicalInsuranceService from "../../../../api/MedicalInsurance/MedicalInsuranceService";
export default class UpdateMedicalInsurance extends Component {
  constructor(props) {
    super(props);

    this.state = {
      allAvailableMedicalInsurances: [],
      selectedMedicalInsurance: {
        id: null,
        class: "",
        mapping: "",
        description: "",
        ar_description: "",
        filePath: "",
        file: null,
        isPreviewed: false,
      },
    };

    this.handleEvent = this.handleEvent.bind(this);
  }

  componentDidMount() {
    this.getAllMedicalInsurances();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.name !== this.state.name) {
      this.handler();
    }
  }

  componentWillUnmount() {}

  // Prototype methods, Bind in Constructor (ES2015)
  handleEvent() {}

  // Class Properties (Stage 3 Proposal)
  handler = () => {
    this.setState();
  };
  getAllMedicalInsurances = () => {
    this.setState({ allAvailableMedicalInsurances: [] });
    medicalInsuranceService
      .getAllInsurances()
      .then((res) => {
        res.data.map((insurance, i) => {
          console.log("category:", insurance);
          return this.setState({
            allAvailableMedicalInsurances: [
              ...this.state.allAvailableMedicalInsurances,
              {
                key: i + 1,
                id: insurance.id,
                class: insurance.class,
                mapping: insurance.mapping,
                description: insurance.description,
                ar_description: insurance.ar_description,
              },
            ],
          });
        });
      })
      .catch((err) => {
        toast.error(err.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      });
  };

  selectMedicalInsurance = () => {
    return this.state.allAvailableMedicalInsurances?.map((insurance) => {
      return (
        <option value={insurance.id}>
          {insurance.class} - {insurance.description}
        </option>
      );
    });
  };

  onSelectMedicalInsurance = (e) => {
    this.state.allAvailableMedicalInsurances.map(
      (insurance) =>
        e.target.value === insurance.id &&
        this.setState({
          selectedMedicalInsurance: {
            id: insurance.id,
            class: insurance.class,
            mapping: insurance.mapping,
            description: insurance.description,
            ar_description: insurance.ar_description,
          },
        })
    );
  };

  updateMedicalInsurance = () => {
    console.log("selected category", this.state.selectedMedicalInsurance);
    medicalInsuranceService.editInsurance(
      this.state.selectedMedicalInsurance.id,
      {
        class: this.state.selectedMedicalInsurance.class,
        mapping: this.state.selectedMedicalInsurance.mapping,
        description: this.state.selectedMedicalInsurance.description,
        ar_description: this.state.selectedMedicalInsurance.ar_description,
        file: this.state.selectedMedicalInsurance.file,
      }
    );
    document.getElementById("class").value = "";
    document.getElementById("mapping").value = "";
    document.getElementById("description").value = "";
    document.getElementById("ar_description").value = "";
    this.setState({
      selectMedicalInsurance: {
        id: null,
        class: null,
        mapping: null,
        description: null,
        ar_description: null,
        filePath: null,
        file: null,
        isPreviewed: false,
      },
    });
    toast.success(`Medical Insurance Updated Successfully`, {
      position: toast.POSITION.TOP_CENTER,
    });
    this.getAllMedicalInsurances();
  };

  onFileSelect = (e) => {
    let selectedMedicalInsurance = this.state.selectedMedicalInsurance;
    selectedMedicalInsurance.file = e.target.files[0];
    this.setState({ selectedMedicalInsurance });
  };

  onChangeMedicalInsuranceData = (e) => {
    let selectedMedicalInsurance = this.state.selectedMedicalInsurance;
    selectedMedicalInsurance[e.target.name] = e.target.value;
    this.setState({ selectedMedicalInsurance });
  };

  render() {
    let selectMedicalInsurance = this.selectMedicalInsurance();
    return (
      <>
        <Row>
          <Col>
            <h5 className="m-0">Update Medical Insurance</h5>
          </Col>
          <Col>
            <div class="form-group" id="role">
              <select
                class="form-control"
                id="role"
                onChange={this.onSelectMedicalInsurance}
              >
                <option value="#">Select Medical Insurance</option>
                {selectMedicalInsurance}
              </select>
            </div>
          </Col>
        </Row>
        <Row form>
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <label>Class</label>
              <FormControl
                autoFocus
                type="text"
                name="class"
                id="class"
                defaultValue={this.state.selectedMedicalInsurance.class}
                onChange={this.onChangeMedicalInsuranceData.bind(this)}
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <label>Mapping</label>
              <FormControl
                autoFocus
                type="text"
                name="mapping"
                id="mapping"
                defaultValue={this.state.selectedMedicalInsurance.mapping}
                onChange={this.onChangeMedicalInsuranceData.bind(this)}
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <label>Description</label>
              <FormControl
                autoFocus
                type="text"
                name="description"
                id="description"
                defaultValue={this.state.selectedMedicalInsurance.description}
                onChange={this.onChangeMedicalInsuranceData.bind(this)}
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <label>Arabic Description</label>
              <FormControl
                autoFocus
                type="text"
                name="ar_description"
                id="ar_description"
                defaultValue={
                  this.state.selectedMedicalInsurance.ar_description
                }
                onChange={this.onChangeMedicalInsuranceData.bind(this)}
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <FormControl
                autoFocus
                type="file"
                name="document"
                id="document"
                onChange={this.onFileSelect.bind(this)}
              />
            </FormGroup>
          </Col>
          <Col
            md="6"
            className="form-group pt-2 align-self-center"
            align="right"
          >
            <Button
              className="btn btn-dark text-white w-25"
              onClick={this.updateMedicalInsurance}
            >
              Update
            </Button>
          </Col>
        </Row>
      </>
    );
  }
}
